import { Outlet } from "react-router-dom";
import { Header } from "./Header";
import { Footer } from "./Footer";
import { ChatWidget } from "./ChatWidget";
import { Cursor } from "./Cursor";
import SmoothScroll from "./SmoothScroll";

export default function PublicLayout() {
  return (
    <SmoothScroll>
      <Cursor />
      <div className="min-h-screen flex flex-col bg-[#F8F9FA]">
        <Header />
        <main className="flex-1">
          <Outlet />
        </main>
        <Footer />
        <ChatWidget />
      </div>
    </SmoothScroll>
  );
}
